// extracted by mini-css-extract-plugin
export default {"dialog":"v1bG7"};